export default __webpack_public_path__ + "static/media/minus.ab058fd4.svg";